import { render, staticRenderFns } from "./DingDing.vue?vue&type=template&id=576c15a7&scoped=true"
import script from "./DingDing.vue?vue&type=script&lang=js"
export * from "./DingDing.vue?vue&type=script&lang=js"
import style0 from "./DingDing.vue?vue&type=style&index=0&id=576c15a7&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c15a7",
  null
  
)

export default component.exports